import { cn as n } from "../../../lib/utils.es.js";
import { jsx as e } from "react/jsx-runtime";
import * as o from "@radix-ui/react-popover";
var p = o.Root, m = o.Trigger, v = o.Anchor, f = ({ className: t, ...i }) => /* @__PURE__ */ e(o.Arrow, {
  className: n("lib:inset-shadow-2xs lib:h-2.5 lib:w-4 lib:fill-popover", t),
  ...i
}), c = ({ className: t, align: i = "center", sideOffset: a = 4, children: r, portal: l, ...s }) => /* @__PURE__ */ e(o.Portal, {
  ...l,
  children: /* @__PURE__ */ e(o.Content, {
    align: i,
    className: n("lib:data-[state=closed]:fade-out-0 lib:data-[state=open]:fade-in-0 lib:data-[state=closed]:zoom-out-95 lib:data-[state=open]:zoom-in-95 lib:data-[side=bottom]:slide-in-from-top-2 lib:data-[side=left]:slide-in-from-right-2 lib:data-[side=right]:slide-in-from-left-2 lib:data-[side=top]:slide-in-from-bottom-2 lib:pointer-events-auto lib:inset-shadow-2xs lib:z-50 lib:w-72 lib:origin-[--radix-popover-content-transform-origin] lib:rounded-xl lib:bg-popover lib:p-4 lib:text-popover-foreground lib:shadow-xl lib:outline-none lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in", t),
    "data-slot": "popover-content",
    sideOffset: a,
    ...s,
    children: r
  })
}), g = ({ className: t, align: i = "center", sideOffset: a = 4, children: r, ...l }) => /* @__PURE__ */ e(o.Content, {
  align: i,
  className: n("lib:data-[state=closed]:fade-out-0 lib:data-[state=open]:fade-in-0 lib:data-[state=closed]:zoom-out-95 lib:data-[state=open]:zoom-in-95 lib:data-[side=bottom]:slide-in-from-top-2 lib:data-[side=left]:slide-in-from-right-2 lib:data-[side=right]:slide-in-from-left-2 lib:data-[side=top]:slide-in-from-bottom-2 lib:pointer-events-auto lib:inset-shadow-2xs lib:z-50 lib:w-72 lib:origin-[--radix-popover-content-transform-origin] lib:rounded-xl lib:bg-popover lib:p-4 lib:text-popover-foreground lib:shadow-xl lib:outline-none lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in", t),
  "data-slot": "popover-content",
  sideOffset: a,
  ...l,
  children: r
});
export {
  p as UiPopover,
  v as UiPopoverAnchor,
  f as UiPopoverArrow,
  c as UiPopoverContent,
  g as UiPopoverContentNonPortal,
  m as UiPopoverTrigger
};
